import { defineMessages } from "react-intl";

export const tableHeaderMessages = defineMessages({
  triggersList: {
    id: "engineMultiConfig.triggers",
    defaultMessage: "Triggers",
  },
});

export const engineMultiConfigMessages = defineMessages({
  entityName: {
    id: "engineMultiConfig.entityName",
    defaultMessage: "Engine Multi Config",
  },
  ticker: {
    id: "engineMultiConfig.ticker",
    defaultMessage: "Ticker",
  },
  triggers: {
    id: "engineMultiConfig.triggers",
    defaultMessage: "Triggers",
  },
  engineMultiConfigJsonLabel: {
    id: "engineMultiConfig.json.label",
    defaultMessage: "json",
  },
  updateSuccessDescription: {
    id: "engineMultiConfig.update.success.description",
    defaultMessage: "Multi Config has been updated",
  },
  jsonReference: {
    id: "engineMultiConfig.actions.jsonReference",
    defaultMessage: "JSON example reference",
  }
});
